import { fetch } from '../../plugin/axios'

const authServer = '/auth'
const maintainServer = '/maintain'

// 列表查询
export function getAssignPageList(data) {
  return fetch({
    url: authServer + '/assign/pageList',
    method: 'POST',
    data
  })
}

// 详情
export function getAssignDetail(params) {
  return fetch({
    url: authServer + '/assign/detail',
    method: 'GET',
    params
  })
}

// 单条保存（编辑）
export function saveAssign(data) {
  return fetch({
    url: authServer + '/assign/save',
    method: 'POST',
    data
  })
}

// 批量保存（新增）
export function saveBatchAssign(data) {
  return fetch({
    url: authServer + '/assign/saveBatch',
    method: 'POST',
    data
  })
}

// 删除
export function deleteAssign(data) {
  return fetch({
    url: authServer + '/assign/delete',
    method: 'POST',
    data
  })
}

// 修改状态
export function changeAssignStatus(data) {
  return fetch({
    url: authServer + '/assign/userChangeStatus',
    method: 'POST',
    data
  })
}

// 员工列表（联动）
export function getUserSimpleList(data) {
  return fetch({
    url: authServer + '/subPlatform/user/simpleList',
    method: 'POST',
    data
  })
}

// 项目列表（联动）
export function getProjectSimpleList(data) {
  return fetch({
    url: maintainServer + '/project/simpleList',
    method: 'POST',
    data
  })
}

// 电梯列表（联动，依赖 projectId）
export function getLiftSimpleList(data) {
  return fetch({
    url: maintainServer + '/lift/simpleList',
    method: 'POST',
    data
  })
}

// 部门列表（联动）
export function getDepartmentSimpleList(params) {
  return fetch({
    url: authServer + '/department/simpleList',
    method: 'GET',
    params
  })
}
